import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { TranslocoService } from '@jsverse/transloco';
import { PRINT_AGENT_CONFIG } from '../../constants/print-agent.config';
import { PrintAgentService } from '../../services/print-agent.service';
import { PrintFlowService } from '../../services/print-flow.service';

@Component({
  selector: 'lib-print-agent-guide',
  standalone: true,
  imports: [DialogModule, ButtonModule],
  templateUrl: './print-agent-guide.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrintAgentGuideComponent {
  private readonly printAgent = inject(PrintAgentService);
  private readonly transloco = inject(TranslocoService);
  private readonly flow = inject(PrintFlowService);

  readonly config = PRINT_AGENT_CONFIG;
  readonly visible = this.flow.guideVisible;
  isChecking = signal(false);
  stillMissing = signal(false);

  open(): void {
    this.stillMissing.set(false);
    this.visible.set(true);
  }

  close(): void {
    this.stillMissing.set(false);
    this.visible.set(false);
  }

  async recheck(): Promise<void> {
    this.isChecking.set(true);
    this.stillMissing.set(false);
    const ok = await this.printAgent.isAvailable();
    this.isChecking.set(false);
    if (ok) {
      this.close();
    } else {
      this.stillMissing.set(true);
    }
  }

  t(key: string, fallback: string): string {
    const value = this.transloco.translate(key);
    return value === key ? fallback : value;
  }
}
